import { render, staticRenderFns } from "./ChatRedeLinear.vue?vue&type=template&id=4d457d48&"
import script from "./ChatRedeLinear.vue?vue&type=script&lang=js&"
export * from "./ChatRedeLinear.vue?vue&type=script&lang=js&"
import style0 from "./ChatRedeLinear.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports